module.exports = __webpack_public_path__ + "img/img3.089dbfc6.png";